import React, { useState } from 'react';
import { Stepper, Step, StepLabel, StepContent, Button, Paper, Typography } from '@mui/material';
import PropTypes from 'prop-types';


import StyledCardNoHeight from '../../components/card/StyledCardNoHeight'
import {
    UserCredential,
    UserGuarantor,
    UserAvatar,
    NewConfessor,
} from '../commonForUsers';
import UserRegistrationForm from './UserRegistrationForm';

export default function Registration({ userToBeUpdated, setUserToBeUpdated, setUserActivatedOn, notification, user }) {
    const [activeStep, setActiveStep] = useState(0);

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleReset = () => {
        setActiveStep(0);
    };

    const handleFinish = () => {
        notification.message = 'የተጠቃሚ ምዝገባ ተሳክቷል።';
        notification.severity = 'success';
        setUserActivatedOn('list');
    };

    return (
        <StyledCardNoHeight sx={{ padding: 5 }}>
            <Stepper activeStep={activeStep} orientation="vertical">
                <Step>
                    <StepLabel >
                        <Typography variant="h6" gutterBottom sx={{ color: 'text.secondary' }}>
                            የአባሉ ዋና መረጃ
                        </Typography>
                    </StepLabel>
                    <StepContent>
                        <UserRegistrationForm
                            setUserToBeUpdated={setUserToBeUpdated}
                            setUserActivatedOn={setUserActivatedOn}
                            notification={notification}
                            handleNext={handleNext}
                        />
                    </StepContent>
                </Step>
                <Step>
                    <StepLabel>
                        <Typography variant="h6" gutterBottom>
                            የአባሉ የፍቃድ መስክ
                        </Typography>
                    </StepLabel>
                    <StepContent>
                        <UserCredential
                            userToBeUpdated={userToBeUpdated}
                            setUserToBeUpdated={setUserToBeUpdated}
                            notification={notification}
                            registerer={user}
                            handleNext={handleNext}
                        />
                    </StepContent>
                </Step>
                <Step>
                    <StepLabel>
                        <Typography variant="h6" gutterBottom>
                            የተከታይ ዋስትና ጨምር
                        </Typography>
                    </StepLabel>
                    <StepContent>
                        <UserGuarantor
                            userToBeUpdated={userToBeUpdated}
                            setUserToBeUpdated={setUserToBeUpdated}
                            notification={notification}
                            handleNext={handleNext}
                        />
                    </StepContent>
                </Step>
                <Step>
                    <StepLabel>
                        <Typography variant="h6" gutterBottom>
                            የአባሉ የነፍስ አባት መረጃ
                        </Typography>
                    </StepLabel>
                    <StepContent>
                        <NewConfessor
                            userToBeUpdated={userToBeUpdated}
                            setUserToBeUpdated={setUserToBeUpdated}
                            notification={notification}
                            updater={user}
                            handleNext={handleNext}
                        />
                    </StepContent>
                </Step>
                <Step>
                    <StepLabel
                        optional={<Typography variant="caption">የመጭረሻ ፎርም</Typography>}
                    >
                        <Typography variant="h6" gutterBottom>
                            የአባሉ ፎቶ
                        </Typography>
                    </StepLabel>
                    <StepContent>
                        <UserAvatar
                            userToBeUpdated={userToBeUpdated}
                            notification={notification}
                            updater={user}
                            handleNext={handleNext}
                        />
                        <Paper square elevation={0} sx={{ p: 3, textAlign: 'right' }}>
                            <Typography variant='h6' color='gray' sx={{ p: 2 }}>ሁሉም የአባል {userToBeUpdated?.firstName}  {userToBeUpdated?.lastName}  ደረጃዎች ተጠናቅቀዋል። - እናመሰናለን!</Typography>
                            <Button onClick={handleReset} sx={{ minWidth: 150 }}>
                                ሌላ አባል መዝግብ
                            </Button>
                            <Button variant="contained" type="submit" sx={{ minWidth: 150 }} onClick={handleFinish}>
                                አጠናቅ
                            </Button>
                        </Paper>
                    </StepContent>
                </Step>
            </Stepper>
        </StyledCardNoHeight>
    );
}

Registration.propTypes = {
    setUserToBeUpdated: PropTypes.func.isRequired,
    notification: PropTypes.shape({
        message: PropTypes.string.isRequired,
        severity: PropTypes.string.isRequired,
    }),
    userToBeUpdated: PropTypes.object.isRequired, 
    setUserActivatedOn: PropTypes.func.isRequired, 
    user: PropTypes.object.isRequired
};
